export const scaffolderMixin = {
  methods: {
    async createDefaultGroup() {
      const group = {
        name: this.editedItem.name || "My New Group",
        code: "G001",
        pricingPlan: "Nucleus",
        features: "",
        adminFullName: this.selectedUser.fullName,
        productTags:
          "Veg,Non-Veg,North Indian,South Indian, Chinese,Starters,Chicken,Sea Food",
        customTags: "Spicy,No Sugar,1by2,2by3,gravy,dry",
        status: 1,
        adminMobile: this.editedItem.adminMobile || "",
        notes: "newly created"
      };
      const response = await this.createDocSync({
        collectionName: "groups",
        doc: group
      });
      this.createDefaultRestaurant(response.id);
      this.createDefaultProduct(response.id);
      this.selectedUser._groupKey = response.id;
      this.selectedUser.role = "GA";
      this.selectedUser.roles = ["GA", "RM", "SS", "SW", "SH", "CC"];
      this.updateDoc({
        collectionName: "users",
        docId: this.selectedUser.id,
        doc: this.selectedUser
      });
      const dbGroup = await this.readDocByIdSync({
        collectionName: "groups",
        docId: response.id,
        predicates: [{ key: "status", op: "==", val: 1 }]
      });
      this.selectGroup(dbGroup);
      this.$router.push("/home");
    },
    async createDefaultRestaurant(groupId, restaurantCode) {
      const restaurant = {
        _groupKey: groupId,
        code: restaurantCode || "R001",
        name: "My New Restaurant " + (restaurantCode || "R001"),
        _managerId: this.selectedUser.id,
        managerName: this.selectedUser.fullName,
        mobile1: "",
        mobile2: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pin: "",
        notes: "",
        status: 1
      };
      const response = await this.createDocSync({
        collectionName: "restaurants",
        doc: restaurant
      });
      await this.createDefaultSection(groupId, response.id);
      await this.createDefaultCounter(groupId, response.id);
    },
    async createDefaultSection(groupId, restaurantId, sectionCode) {
      const section = {
        _groupKey: groupId,
        _restaurantKey: restaurantId,
        code: sectionCode || "S1",
        name: "New Section " + (sectionCode || "S1"),
        tables: [
          {
            active: false,
            height: 60,
            id: "_dit1drcbc",
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 65,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_dit1drcbc",
                type: "seat",
                width: 20,
                x: 65,
                y: 35
              }
            ],
            type: "table",
            width: 90,
            x: 10,
            y: 10
          },
          {
            active: false,
            angle: 45,
            height: 60,
            id: "_82xwree4h",
            rx: 30,
            ry: 30,
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_82xwree4h",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_82xwree4h",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_82xwree4h",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_82xwree4h",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              }
            ],
            type: "table",
            width: 60,
            x: 160,
            y: -5
          },
          {
            active: false,
            height: 60,
            id: "_g6h2g9v11",
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_g6h2g9v11",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_g6h2g9v11",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_g6h2g9v11",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_g6h2g9v11",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              }
            ],
            type: "table",
            width: 60,
            x: 220,
            y: 10
          },
          {
            active: false,
            height: 60,
            id: "_2f2lw3xmo",
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_2f2lw3xmo",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_2f2lw3xmo",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_2f2lw3xmo",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_2f2lw3xmo",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              }
            ],
            type: "table",
            width: 60,
            x: 10,
            y: 130
          },
          {
            active: false,
            angle: -45,
            height: 60,
            id: "_m7zq7s6f9",
            rx: 30,
            ry: 30,
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_m7zq7s6f9",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_m7zq7s6f9",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_m7zq7s6f9",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_m7zq7s6f9",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              }
            ],
            type: "table",
            width: 60,
            x: 85,
            y: 160
          },
          {
            active: false,
            height: 60,
            id: "_asf7qnmqt",
            seats: [
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 5,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 35,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 65,
                y: 5
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 5,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 35,
                y: 35
              },
              {
                _serviceKey: "",
                active: false,
                color: "#90ee90",
                height: 20,
                parentId: "_asf7qnmqt",
                type: "seat",
                width: 20,
                x: 65,
                y: 35
              }
            ],
            type: "table",
            width: 90,
            x: 190,
            y: 130
          }
        ],
        _supervisorId: this.selectedUser.id,
        _waiterId: this.selectedUser.id,
        _helperId: this.selectedUser.id,
        supervisorName: this.selectedUser.fullName,
        waiterName: this.selectedUser.fullName,
        helperName: this.selectedUser.fullName,
        notes: "default section",
        status: 1
      };
      await this.createDocSync({
        collectionName: "sections",
        doc: section
      });
    },
    async createDefaultCounter(groupId, restaurantId, counterCode) {
      const counter = {
        _groupKey: groupId,
        _restaurantKey: restaurantId,
        code: counterCode || "C1",
        name: "New Counter " + (counterCode || "C1"),
        status: 1,
        _chefId: this.selectedUser.id,
        chefName: this.selectedUser.fullName,
        notes: "default counter"
      };
      await this.createDocSync({
        collectionName: "counters",
        doc: counter
      });
    },
    async createDefaultProduct(groupId, productCode) {
      let product = {
        _groupKey: groupId,
        isGroupProduct: true,
        code: productCode || "P001",
        name: "New Product 1",
        rate: "1.0",
        taxPlan: "NA",
        managerFee: "1.0",
        supervisorFee: "1.0",
        waiterFee: "1.0",
        helperFee: "1.0",
        chefFee: "1.0",
        count: "",
        tags: [],
        imageUrl: "",
        desc: "",
        status: 1
      };
      await this.createDocSync({
        collectionName: "products",
        doc: product
      });
    }
  }
}